// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"edc3c798","453":"5925308c"}[chunkId] + ".chunk.js";
};